import styles from './Service.module.css';

import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import img1 from '../../assets/icons/circle.png';
import img2 from '../../assets/imgs/img10.png';



export const Service = () => {
  return (
    <div>
        <Container className={`${styles.section}`}>
        <h2 className={` ms-auto me-auto ${styles.title}`}>Take advantage of more amazing solutions on ULLWEB</h2>

            <Row className={`${styles.row}`}>

            <Col lg={6} sm={12} xs={12} md={6}>
           <div className={`${styles.imgcol}`}>
            <img src={img2} alt='service sectionimage' className={`${styles.img}`} />
            </div>
            </Col>

            <Col lg={6} sm={12} xs={12} md={6}>
                <div>
                    <h2 className={`${styles.free}`}>Freelance Service Providers</h2>
                    <p className={`${styles.desc}`}>Get top-rated service providers that works according
                        to your budget and timeline, your budget shouldn’t 
                        stop your business from going online.</p>
                </div>
            </Col>
            </Row>
        </Container>
    </div>
  )
}
